import React from 'react';
import useWizardFormCtx from '../ctx-provider/useWizardFormCtx';
import BtnNavBack from '../../../cmp/nav/BtnNavBack';

const BtnBack: React.FC = () => {
    const { handleBackPage } = useWizardFormCtx();
    return <BtnNavBack onClick={handleBackPage} />
}

export default BtnBack;